import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import TrustBar from "./components/TrustBar";
import CategorySection from "./components/CategorySection";
import BenefitsSection from "./components/BenefitsSection";
import ComparisonTable from "./components/ComparisonTable";
import TestimonialsSection from "./components/TestimonialsSection";
import ArticlesSection from "./components/ArticlesSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <CategorySection />
        <BenefitsSection />
        <ComparisonTable />
        <TestimonialsSection />
        <ArticlesSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}